import { Workbook, WorkbookUpdateFormValues } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPatch } from '../../../types/ConstructPatch';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const patchApplicationWorkbook = async (
  constructPatch: ConstructPatch,
  uuid: string,
  definitionName: string,
  data: WorkbookUpdateFormValues,
): Promise<NonPaginatedResponse<Workbook> | undefined> =>
  constructPatch(
    `${APPLICATION_BASE_PATH}/${uuid}/workbook`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
